import { useMemo } from "react";
import { useXcoreCore } from "../useXcoreCore";
import { xcoreDataUtils } from "./utils";

export * from "./utils";

/**
 * Just a wrapper for `xcoreDataUtils`.
 * If you already have `core` instance in code you can use `xcoreDataUtils` directly.
 * */
export const useXcoreUtils = () => {
  const core = useXcoreCore();
  const { video, image, localize, stringify, richtextToString, formatDate } = useMemo(() => xcoreDataUtils(core), [core]);
  return {
    /**
     * Resolves self hosted video url from video id.
     *
     * @param videoId `number`, video id.
     * */
    video,
    /**
     * Resolves image url from image id, mime and other image options.
     * File `mime` can be overridden by specifying `ext` prop.
     *
     * @param id `number`, image id.
     * @param size `string`, cannot be empty string. If so, default value of "1440x750" will be used for size.
     * @param mime `"image/png" | "image/jpg" | "image/jpeg"`.
     * */
    image,
    /**
     * Accepts localized or non localized value. If value is localized it is resolved with current or fallback locale.
     * If current or fallback locale isn't available in provided localized value `null` value will be returned.
     *
     * @param contentValue `ContentValue`
     * */
    localize,
    /**
     * Works just like `localize()` only difference is
     * that it accepts only `string` or localized `string` and returns empty `string`
     * if current or fallback locale isn't available in provided localized value.
     * @param stringValue `string | Localized<string> | undefined`
     * */
    stringify,
    /**
     * Accepts localized or non localized richtext value and parses it to string.
     * New lines are joined by `\n`.
     *
     * @param richtextValue `RichtextValue | Localized<RichtextValue> | undefined`
     */
    richtextToString,
    /**
     * Accepts localized or non localized `Date` value and parses it to string in format `DD/MM/YYYY`.
     * Resolves date based on current or fallback locale.
     *
     * @param dateValue `Date | Localized<Date> | undefined`
     */
    formatDate,
  };
};
